import React from 'react';
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Link } from 'react-router-dom';
import AccountProfileDetails from '../components/account/AccountProfileDetails';
import SettingsPasswordDashboard from '../components/account/SettingsPasswordDashboard';
import Topbar from "./Topbar";
import Loading from "./Loading"

const ArrowLeftIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 16, height: 16 }}>
    <path d="M19 12H5M12 19l-7-7 7-7"/>
  </svg>
);

const getUser = async () => {
  try {
    let solicitudes = await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_GET_USER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getCookie('asa_hd_auth')}` },
      body: JSON.stringify({})
    })
    if (solicitudes.ok) {
      const _solicitudes = await solicitudes.json();
      return _solicitudes;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export default function Account(props) {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    getUser().then(x => {
      setUser(x)
      setLoading(false)
    })

  }, []);
  return (
    <React.Fragment>
      {loading ? <Loading color={"#00000024"} height={"100%"} width={"100%"} />: null}
        <Topbar />
        <div style={{ padding: '20px 24px 0' }}>
          <Link to="/home" className="ds-btn ds-btn-ghost ds-btn-sm" style={{ display: 'inline-flex', alignItems: 'center', gap: 7, textDecoration: 'none' }}>
            <ArrowLeftIcon /> Volver al inicio
          </Link>
        </div>
        {user ?
          <Box
            sx={{
              backgroundColor: 'background.default',
              minHeight: '100%',
              py: 3
            }}
          >
            <Container maxWidth="lg">
              <Box sx={{ pt: 3 }}>
                <AccountProfileDetails user={user} />
              </Box>
              <Box sx={{ pt: 3 }}>
                <SettingsPasswordDashboard />
              </Box>
            </Container>
          </Box>
          : null}
    </React.Fragment>
  )
}
